import getCardPreferanceService from '../services/components/get_cardpreferance.jsx'


const getState = (cardPreferanceState) => ({ type: "GET_CARDPREFERANCE", cardPreferanceState})

export const getCardPreferanceAction = (cardDetailsId) => dispatch => {
    let state = [];

    getCardPreferanceService((data, msg) => {
        if (msg === "success") {
            state = {
                status: 200,
                body: data
            }
          //   localStorage.setItem("alertState", JSON.stringify(state))
        } else if(msg === "sessionout"){
            state={
                message: "sessionout",
                status: 401,
                body: data 
            }
        } else {
            state = data
        }
        dispatch(getState(state))
    },cardDetailsId)
} 


// WEBPACK FOOTER //
// ./src/actions/getcardpreferance.jsx